import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueCookie from 'vue-cookie';

Vue.use(VueI18n);
Vue.use(VueCookie);

export default new VueI18n({
  locale: VueCookie.get('lang') || process.env.VUE_APP_DEFAULT_LANGUAGE,
  fallbackLocale: process.env.VUE_APP_DEFAULT_LANGUAGE,
  messages: {
    en: require('../locale/en.json')
  },
  silentTranslationWarn: true
});
